// @flow
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { ApiKeysActionTypes } from './constants';
import { apiKeysApiResponseError, apiKeysApiResponseSuccess } from './actions';
import { addToast } from '../actions';
import { createUserApiKey, deleteUserApiKey, getUserApiKeys } from '../../helpers';
import { convertKeysToCamelCase } from '../../utils/convert';

function* apiKeysGetAll({ payload: { userId } }) {
    try {
        const response = yield call(getUserApiKeys, userId);
        const apiKeys = (response?.data || []).map((apiKey) => convertKeysToCamelCase(apiKey));
        yield put(apiKeysApiResponseSuccess(ApiKeysActionTypes.GET_ALL_API_KEYS, apiKeys));
    } catch (error) {
        yield put(
            addToast({ desc: error?.errors?.[0]?.message || 'Unable to load API keys', type: 'error' })
        );
        yield put(apiKeysApiResponseError(ApiKeysActionTypes.GET_ALL_API_KEYS, error));
    }
}

function* apiKeysCreate({ payload: { userId } }) {
    try {
        const response = yield call(createUserApiKey, userId);
        const apiKey = convertKeysToCamelCase(response?.data || {});
        yield put(apiKeysApiResponseSuccess(ApiKeysActionTypes.CREATE_API_KEY, apiKey));
        yield put(addToast({ desc: 'API key created successfully.', type: 'success' }));
    } catch (error) {
        yield put(
            addToast({ desc: error?.errors?.[0]?.message || 'Unable to create API key', type: 'error' })
        );
        yield put(apiKeysApiResponseError(ApiKeysActionTypes.CREATE_API_KEY, error));
    }
}

function* apiKeysDelete({ payload: { userId, apiKeyId } }) {
    try {
        yield call(deleteUserApiKey, userId, apiKeyId);
        yield put(apiKeysApiResponseSuccess(ApiKeysActionTypes.DELETE_API_KEY, apiKeyId));
        yield put(addToast({ desc: 'API key deleted successfully.', type: 'success' }));
    } catch (error) {
        yield put(
            addToast({ desc: error?.errors?.[0]?.message || 'Unable to delete API key', type: 'error' })
        );
        yield put(apiKeysApiResponseError(ApiKeysActionTypes.DELETE_API_KEY, error));
    }
}

function* watchApiKeysGetAll() {
    yield takeLatest(ApiKeysActionTypes.GET_ALL_API_KEYS, apiKeysGetAll);
}

function* watchApiKeysCreate() {
    yield takeLatest(ApiKeysActionTypes.CREATE_API_KEY, apiKeysCreate);
}

function* watchApiKeysDelete() {
    yield takeLatest(ApiKeysActionTypes.DELETE_API_KEY, apiKeysDelete);
}

export default function* apiKeysSaga() {
    yield all([fork(watchApiKeysGetAll), fork(watchApiKeysCreate), fork(watchApiKeysDelete)]);
}
